import Task from "./task";
export default class Project {
  #title;
  #todoList = [];

  constructor(title) {
    if (!new.target) {
      throw Error("Use the new operator to create a new object.");
    }
    this.#title = title;
  }

  addTask(title, description, dueDate, priority, completedStatus) {
    const task = new Task(
      title,
      description,
      dueDate,
      priority,
      completedStatus
    );
    this.#todoList.push(task);
    console.log("Task added successfully");
    return task;
  }

  addExistingTask(taskAsJSON) {
    let task = new Task(
      taskAsJSON.title,
      taskAsJSON.description,
      new Date(taskAsJSON.dueDate),
      taskAsJSON.priority,
      taskAsJSON.completedStatus
    );
    task.setId(taskAsJSON.id);
    this.#todoList.push(task);
    return task;
  }

  removeTask(task) {
    this.#todoList = this.#todoList.filter((item) => item !== task);
  }

  getTasks() {
    return [...this.#todoList];
  }

  getTask(id) {
    return this.#todoList.find((task) => task.getId() === id);
  }

  renameProject(title) {
    this.#title = title;
  }

  getProjectTitle() {
    return this.#title;
  }
}
